<div class="notification-container">
  <!-- Unseen Notification -->
  <div 
    class="notification-card unread" 
    (click)="onClickNotif()" 
    *ngIf="notification?.seen == false"
    [@fadeIn]
  >
    <div class="notification-content">
      <div class="avatar-container">
        <img
          class="avatar-img"
          alt="User avatar"
          [src]="
            notification?.notification?.relatedTo?.avatar?.public_url
              ? (isDemoMode ? '' : BASE_API) + 
                notification?.notification?.relatedTo?.avatar?.filename
              : 'assets/img/Main_Logo_Color.png'
          "
        />
      </div>
      
      <div class="notification-details">
        <p class="notification-message">{{ notification?.notification?.content }}</p>
        <div class="notification-meta">
          <span class="timestamp">{{ notification.notification.createdAt | date :'MMM d, h:mm a' }}</span>
          <span class="unread-badge">جديد</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Seen Notification -->
  <div 
    class="notification-card" 
    (click)="onClickNotif()" 
    *ngIf="notification?.seen == true"
    [@fadeIn]
  >
    <div class="notification-content">
      <div class="avatar-container">
        <img
          class="avatar-img"
          alt="User avatar"
          [src]="
            notification?.notification?.relatedTo?.avatar?.public_url
              ? (isDemoMode ? '' : BASE_API) +
                notification?.notification?.relatedTo?.avatar?.filename
              : 'assets/img/Main_Logo_Color.png'
          "
        />
      </div>
      
      <div class="notification-details">
        <p class="notification-message">{{ notification?.notification?.content }}</p>
        <div class="notification-meta">
          <span class="timestamp">{{ notification.notification.createdAt | date :'MMM d, h:mm a' }}</span>
        </div>
      </div>
    </div>
  </div>
</div>